import Component from "./UploadMasavConfirmation"
import { Actions } from "../actions"
import { connect } from "react-redux"
import { Selectors } from "../../modules/masavExports"

export default connect((state) => ({
    currentExport: Selectors.getCurrentExport(state),
    loading: Selectors.getLoading(state),
    isSubmitting: Selectors.getIsSubmitting(state),
    uploadSuccess: Selectors.getUploadSuccess(state),
    error: Selectors.getError(state),
}), {
    onMount: Actions.SINGLE_MASAV_EXPORT_PAGE_MOUNTED,
    onSubmit: Actions.UPLOAD_MASAV_CONFIRMATION_SUBMITTED,
})(Component)

